import { useEffect } from "react"

export function stickyNavigation(onScroll:any){
    useEffect(()=>{
        const media = window.matchMedia('(min-width:1024px)');
        if(!media.matches) return;
        window.addEventListener("scroll",onScroll);
        return(()=> window.removeEventListener('scroll',onScroll))
    },[onScroll])

}